// extracted by mini-css-extract-plugin
export default {"adminNavWrapper":"AdminNavbar_adminNavWrapper__1IMHs","navContainer":"AdminNavbar_navContainer__JNMhp","navLink":"AdminNavbar_navLink__93WH-","active":"AdminNavbar_active__MAOe-"};